export default __webpack_public_path__ + "static/media/BrisaRegular.6afd2431.ttf";